const initIubendaProof = () => {
    document.querySelectorAll('form[method=POST]').forEach(function (value) {
        const html = btoa(encodeURI(value.innerHTML));
        const textArea = document.createElement("textarea");
        const innerText = document.createTextNode(html);
        textArea.name = "iubenda_proof";
        textArea.style.display = "none";
        value.appendChild(textArea);
        textArea.appendChild(innerText);
    });
};
